import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/layout/index';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/login',
      children: [
        {
          path: '/sea/transportation',
          name: 'SeaTransportation',
          component: resolve => { require(['@/views/sea/transportation'], resolve) }
        },
        {
          path: '/sea/transportation/details',
          name: 'SeaTransportationDetails',
          component: resolve => { require(['@/views/sea/details'], resolve) }
        },
        {
          path: '/sea/transportation/againConfirm',
          name: 'SeaTransportationAgainConfirm',
          component: resolve => { require(['@/views/sea/again-confirm'], resolve) }
        },
        {
          path: '/land/transportation',
          name: 'LandTransportation',
          component: resolve => { require(['@/views/Land/transportation'], resolve) }
        },
        {
          path: '/land/transportation/againConfirm',
          name: 'LandTransportationAgainConfirm',
          component: resolve => { require(['@/views/land/again-confirm'], resolve) }
        },
        {
          path: '/seaPiece/transportation',
          name: 'SeaPieceTransportation',
          component: resolve => { require(['@/views/sea-piece/transportation'], resolve) }
        },
        {
          path: '/sea/piece/transportation/details',
          name: 'SeaPieceTransportationDetails',
          component: resolve => { require(['@/views/sea-piece/details'], resolve) }
        },
        {
          path: '/sea/piece/transportation/againConfirm',
          name: 'SeaPieceTransportationAgainConfirm',
          component: resolve => { require(['@/views/sea/again-confirm'], resolve) }
        },
        {
          path: '/user/order/list',
          name: 'UserOrderList',
          component: resolve => { require(['@/views/user/order-list'], resolve) }
        },
        {
          path: '/courier/query/offer',
          name: 'CourierQueryOffer',
          component: resolve => { require(['@/views/courier/queryOffer'], resolve) }
        },
        {
          path: '/courier/query/offer/againConfirm',
          name: 'CourierQueryOfferAagainConfirm',
          component: resolve => { require(['@/views/courier/again-confirm'], resolve) }
        },
        {
          path: '/home',
          name: 'Home',
          component: resolve => { require(['@/views/home/index'], resolve) }
        },
      ]
    },
    {
      path: '/login/re',
      name: 'LoginRe',
      component: resolve => { require(['@/views/login/index'], resolve) }
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve => { require(['@/views/login/index-plus'], resolve) }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // if (to.name != 'Login' && sessionStorage.getItem('isLogin') != '1') {
  //   if (from.name != 'Login') {
  //     router.push({name: 'Login'})
  //   }
  //   return;
  // }
  NProgress.start();
  next();
})

router.afterEach(() => {
  NProgress.done()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js